// @flow
/* eslint no-restricted-globals: off */

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

const tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  if (!el.style) return undefined;
  return el.style.display === 'none' || (el.style.visibility && el.style.visibility === 'hidden');
}

function visible(element) {
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  const nodeName = element.nodeName.toLowerCase();
  const res =
    (tabbableNode.test(nodeName) && !element.disabled) ||
    (nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element): boolean {
  const tabIndex = element.getAttribute('tabindex');
  // isTabIndexNaNOrNull checks if value is number or not a null.
  const isTabIndexNaNOrNull = (() => {
    if (tabIndex === null) {
      return true;
    }

    return isNaN(tabIndex);
  })();

  if (isTabIndexNaNOrNull) {
    return focusable(element, !isTabIndexNaNOrNull);
  }

  return false;
}

export default function findTabbableDescendants(
  element: HTMLElement,
): Array<HTMLElement | HTMLAnchorElement | HTMLButtonElement> {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}
